import { appSystemKey, parseAppSystem } from "nlb-buy-go-library-v2";
import { createApp } from "vue";
import App from "@/app/app.vue";
import { i18n } from "@app/i18n";
import vuetify from "@app/plugins/vuetify";
import "@/app/styles/main.scss";
import { loadFonts } from "@app/plugins/webfontloader";
import { createPinia } from "pinia";
import router from "@app/router";
import { injectGTM, removeGTM } from "./utils/gtm";

import Datepicker from "@vuepic/vue-datepicker";
import * as Sentry from "@sentry/vue";

loadFonts()

const app = createApp(App);
app.provide(appSystemKey, parseAppSystem(import.meta.env.MODE));

declare global {
  interface Window {
    ScarabQueue?: unknown[];
  }
}

window.ScarabQueue ??= [];

function injectScarab(): void {
  window.ScarabQueue ??= [];

  const id = "scarab-js-api";
  if (document.getElementById(id)) return;

  const script = document.createElement("script");
  script.id = id;
  script.src =
    "//cdn.scarabresearch.com/js/12E95685992323A5/scarab-v2.js";

  const firstScript = document.getElementsByTagName("script")[0];
  firstScript.parentNode?.insertBefore(script, firstScript);
}

if (import.meta.env.MODE === "PROD") {
    Sentry.init({
        app,
        release: `${__APP_VERSION__}`,
        dsn: "https://c223db4df0611e813c4027b8239ac525@o4509208598806528.ingest.de.sentry.io/4509208631771216",
        // Setting this option to true will send default PII data to Sentry.
        // For example, automatic IP address collection on events
        sendDefaultPii: true
    });

    injectGTM('GTM-KGZ468DH');
    injectScarab();
}
  
app.component("Datepicker", Datepicker)
.use(vuetify)
.use(createPinia())
.use(router)
.use(i18n)
.mount("#app");

console.log("version: " + `${__APP_VERSION__}`);
